import React, { ReactElement } from 'react'
import { StyledAdmin } from '../styled-components'
import { TrainingGroup } from '../../../types/training'
import PartsCards from '../../../components/Admin/part/preview-part'

interface AdminCategoryProps {
  trainingsGroup: TrainingGroup
  categoryId: string
}

const AdminCategory = ({
  trainingsGroup,
  categoryId,
}: AdminCategoryProps): ReactElement => (
  <StyledAdmin>
    <PartsCards categoryId={categoryId} trainingsGroup={trainingsGroup} />
  </StyledAdmin>
)

export default AdminCategory
